"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalTimeframe = void 0;
var LegalTimeframe;
(function (LegalTimeframe) {
    LegalTimeframe["DAY"] = "1d";
    LegalTimeframe["WEEK"] = "1w";
    LegalTimeframe["TWO_WEEKS"] = "2w";
    LegalTimeframe["MONTH"] = "1m";
    LegalTimeframe["THREE_MONTHS"] = "3m";
    LegalTimeframe["SIX_MONTHS"] = "6m";
    LegalTimeframe["YEAR"] = "1y";
    LegalTimeframe["TWO_YEARS"] = "2y";
    LegalTimeframe["ALL"] = "all";
    LegalTimeframe["DEFAULT"] = "default";
    LegalTimeframe["CUSTOM"] = "custom";
})(LegalTimeframe = exports.LegalTimeframe || (exports.LegalTimeframe = {}));
//# sourceMappingURL=legalTimeframe.enum.js.map